(ns vit-configurator.views.analytics
  (:require [re-frame.core :as re-frame]
            [reagent.core :as reagent]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]
            [vit-configurator.views.shared :as shared]))

(def analytics-text
  "By default, the Voter Information Tool sends analytics to a Democracy
 Works account. It can also be setup to send analytics to your own account
 if you already have it setup on the page hosting the VIT, so long as you are
 also using the ga.js API. We can send pageview events to the default tracker
 or to a named tracker.")

(defn radio-button [id value current-value]
  (letfn [(change-fn [_]
            (re-frame/dispatch [::events/set-analytics
                                value]))]
    [:input (merge {:type "radio" :name "analytics" :value value
                    :on-change change-fn :id id}
                   (if (= value current-value)
                     {:checked true}
                     {:checked false}))]))

(defn customizer
  []
  (let [analytics @(re-frame/subscribe [::subs/analytics])]
    [:fieldset#analytics
     [:legend analytics-text]
     [:div
      [radio-button "analytics-off" :off analytics]
      [:label.pl-1.pr-4 {:for "analytics-off"}
       "Off (send pageviews to Democracy Works ONLY)"]]
     [:div
      [radio-button "analytics-custom" :custom analytics]
      [:label.pl-1.pr-4.mb-0 {:for "analytics-custom"}
       "Use my custom GA4 tracker"]
      (when (= :custom analytics)
        [:div.mt-2
         [:label.pl-1.pr-4.mb-0 {:for "analytics-custom-name"}
          "Custom tracker name"]
         [:input.mw-100.mb-0 {:type "text" :name "tracker-name"
                  :id "analytics-custom-name" :placeholder "e.g. G-XXXXXXXXXX"
                  :on-change (fn [evt]
                               (let [val (.. evt -target -value)]
                                 (re-frame/dispatch [::events/set-analytics-custom val])))}]])]]))
